module.exports = __webpack_public_path__ + "img/cdz.2225e960.png";